import React, { useState } from 'react';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { HiMenuAlt3 } from 'react-icons/hi';
import logo from '../../assest/logo.png';
import { Link } from 'react-router-dom';
import './CustomNavbar.css';

const CustomNavbar = () => {
  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => {
    setExpanded(prev => !prev);
  };

  const closeMenu = () => {
    setExpanded(false);
  };

  const navItems = [
    { path: '/', label: 'الرئيسية' },
  ];

  const saleItems = [
    { path: '/properties/apartment/sale', label: 'شقق للبيع' },
    { path: '/properties/land/sale', label: 'أراضي للبيع' },
    { path: '/properties/house/sale', label: 'بيوت للبيع' },
  ];

  const rentItems = [
    { path: '/properties/apartment/rent', label: 'شقق للإيجار' },
    { path: '/properties/house/rent', label: 'بيوت للإيجار' },
  ];

  return (
    <Navbar 
      fixed="top" 
      expand="lg" 
      className="custom-navbar py-2 shadow-sm" 
      dir="rtl"
      expanded={expanded}
    >
      <Container>
        <div className="d-flex align-items-center">
          <Navbar.Toggle 
            aria-controls="main-nav" 
            className="navbar-toggler ms-2"
            onClick={handleToggle}
          >
            <HiMenuAlt3 size={28} color="#003591" />
          </Navbar.Toggle>

          <Navbar.Brand 
            as={Link} 
            to="/" 
            className="brand-wrapper m-0" 
            onClick={closeMenu}
          >
            <div className="logo-container">
              <img src={logo} alt="Bayti Logo" className="logo-img" />
            </div>
            <div className="brand-info">
              <span className="brand-name">Bayti بيتي</span>
            </div>
          </Navbar.Brand>
        </div>

        <Navbar.Collapse id="main-nav">
          <Nav className="me-auto mt-3 mt-lg-0 align-items-center text-end">
            {navItems.map((item) => (
              <Nav.Link 
                key={item.path}
                as={Link} 
                to={item.path} 
                onClick={closeMenu} 
                className="fw-bold"
              >
                {item.label}
              </Nav.Link>
            ))}
            
            <NavDropdown 
              title="عقارات للبيع" 
              id="sale-dropdown" 
              className="fw-bold"
            >
              {saleItems.map((item) => (
                <NavDropdown.Item 
                  key={item.path}
                  as={Link} 
                  to={item.path} 
                  onClick={closeMenu}
                >
                  {item.label}
                </NavDropdown.Item>
              ))}
            </NavDropdown>

            <NavDropdown 
              title="عقارات للإيجار" 
              id="rent-dropdown" 
              className="fw-bold"
            >
              {rentItems.map((item) => (
                <NavDropdown.Item 
                  key={item.path}
                  as={Link} 
                  to={item.path} 
                  onClick={closeMenu}
                >
                  {item.label}
                </NavDropdown.Item>
              ))}
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default CustomNavbar;